import React, { useRef } from 'react';
import Script from 'next/script';
import ChevronRightIcon from '../../../icons/chevron-right';
import QuestionmarkFilledIcon from '../../../icons/questionmark-filled';
import Button from '../button';

interface Props {
  srcLink: string;
  configUrl: string;
  showButton?: boolean;
  buttonText?: string;
}

export const landbot = { current: null };

const LiveChat: React.FC<Props> = ({ srcLink, configUrl, showButton, buttonText }) => {
  const setUpLandbot = () => {
    // @ts-ignore
    landbot.current = new Landbot.Livechat({
      configUrl: configUrl,
    });
  };

  const handleLandbotClick = () => {
    landbot?.current.open();
  };

  return (
    <>
      {showButton && landbot.current && (
        <Button style="secondary" onClick={handleLandbotClick}>
          <span className="flex items-center gap-2">
            <QuestionmarkFilledIcon className="size-7 fill-white" aria-hidden="true" />
            {buttonText}
            <ChevronRightIcon className="size-6 fill-white" aria-hidden="true" />
          </span>
        </Button>
      )}
      <Script src={srcLink} onLoad={setUpLandbot} />
    </>
  );
};

export default LiveChat;
